//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ACCESS_TYPE_FLOW } from '@/js/constants';
import ListTablesAccessRequested from '@/components/ListTablesAccessRequested';
import ListDatasourceAccessRequested from '@/components/ListDatasourceAccessRequested';
import ListWorkbookAccessRequested from '@/components/ListWorkbookAccessRequested';
import ListDatasetAccessRequested from '@/modules/tasks/powerbi/ListDatasetAccessRequested';
import ListReportAccessRequested from '@/modules/tasks/powerbi/ListReportAccessRequested';
import ListReportAccessRequestedGds from '@/modules/tasks/datastudio/ListReportAccessRequestedGDS';
import ListDatasourceAccessRequestedGds from '@/modules/tasks/datastudio/ListDatasourceAccessRequestedGDS';
import { tabsMixin } from '@/mixins/tabs_mixim';
import tasks from '@/js/tasks';
export default {
  name: 'ChangeMetadataRequestPage',
  mixins: [tabsMixin],
  components: {
    ListTablesAccessRequested: ListTablesAccessRequested,
    ListDatasourceAccessRequested: ListDatasourceAccessRequested,
    ListWorkbookAccessRequested: ListWorkbookAccessRequested,
    ListDatasetAccessRequested: ListDatasetAccessRequested,
    ListReportAccessRequested: ListReportAccessRequested,
    ListReportAccessRequestedGds: ListReportAccessRequestedGds,
    ListDatasourceAccessRequestedGds: ListDatasourceAccessRequestedGds
  },
  data: function data() {
    return {
      DIALOG_CONFIRM_MASSIVE_APPROVE: 'DIALOG_CONFIRM_MASSIVE_APPROVE',
      TYPE_FLOW: ACCESS_TYPE_FLOW.CHANGE_METADATA,
      TITLE_PAGE: 'Change metadata requests',
      filter_enabled: false,
      //true,
      text_filter: '',
      typeSelected: 1,
      status_filter: 'REVISION',
      is_view: false,
      btn_approve_id: 1,
      rowsSelected: []
    };
  },
  computed: {
    tab: function tab() {
      return {
        tables: this.traductor('tabs.tables'),
        tbl_datasources: this.traductor('tabs.tbl_datasources'),
        tbl_dashboards: this.traductor('tabs.tbl_dashboards'),
        pbi_datasets: this.traductor('tabs.pbi_datasets'),
        pbi_reports: this.traductor('tabs.pbi_reports'),
        gds_reports: this.traductor('tabs.gds_reports'),
        gds_datasources: this.traductor('tabs.gds_datasources')
      };
    },
    object_types: function object_types() {
      return [{
        value: 1,
        text: this.traductor('my_pendings.tables')
      }, {
        value: 2,
        text: this.traductor('my_pendings.datasources')
      }, {
        value: 3,
        text: this.traductor('my_pendings.dashboards')
      }, {
        value: 4,
        text: this.traductor('my_pendings.datasets')
      }, {
        value: 5,
        text: this.traductor('my_pendings.reports')
      }, {
        value: 6,
        text: this.traductor('my_pendings.reports_lds')
      }, {
        value: 7,
        text: this.traductor('my_pendings.datasources_lds')
      }];
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.getTitleChange(this.typeSelected - 1),
        disabled: true
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    status_list: function status_list() {
      return [{
        value: "REVISION",
        text: this.traductor('my_pendings.revision')
      }, {
        value: "APPROVED",
        text: this.traductor('my_pendings.approved')
      }, {
        value: "REJECTED",
        text: this.traductor('my_pendings.rejected')
      }];
    },
    getRefByTypeSelected: {
      get: function get() {
        return "listRef".concat(this.typeSelected);
      }
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onItemAdded: function onItemAdded() {
      this.btn_approve_id += 1;
    },
    getTotalSelected: function getTotalSelected() {
      var refSelected = this.$refs[this.getRefByTypeSelected];
      if (refSelected) {
        this.rowsSelected = refSelected.getRowsSelected();
        return this.rowsSelected.length;
      } else {
        return 0;
      }
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      this.is_view = this.status_filter == 'REVISION' ? false : true;
      this.$refs["listRef" + this.typeSelected].onSearch(this.text_filter, this.status_filter);
    },
    onLimpiar: function onLimpiar() {
      console.log(this.text_filter);
      this.text_filter = "";
      this.$refs["listRef" + this.typeSelected].onSearch(this.text_filter);
      switch (this.typeSelected) {
        case 1:
          this.$refs["listRef" + this.typeSelected].reloadList();
          break;
        case 2:
          this.$refs["listRef" + this.typeSelected].reloadDataSource();
          break;
        case 3:
          this.$refs["listRef" + this.typeSelected].reloadWorkBook();
          break;
        case 4:
          this.$refs["listRef" + this.typeSelected].reloadDataset();
          break;
        case 5:
          this.$refs["listRef" + this.typeSelected].reloadReport();
          break;
        case 6:
          this.$refs["listRef" + this.typeSelected].reloadReport();
          break;
        case 7:
          this.$refs["listRef" + this.typeSelected].reloadDatasourceDS();
          break;
      }
    },
    onChangeType: function onChangeType() {
      this.text_filter = "";
    },
    onOpenDialogMassiveApprove: function onOpenDialogMassiveApprove() {
      var refSelected = this.$refs[this.getRefByTypeSelected];
      this.rowsSelected = refSelected.getRowsSelected();
      if (!this.rowsSelected.length) {
        tasks.toast.error('Debe seleccionar al menos una solicitud');
        return;
      }
      this.$refs[this.DIALOG_CONFIRM_MASSIVE_APPROVE].onOpen();
    },
    onConfirmMassiveApprove: function onConfirmMassiveApprove(confirm) {
      if (confirm) {
        var refSelected = this.$refs[this.getRefByTypeSelected];
        refSelected.massiveApprove(this.typeSelected, "CHANGE_METADATA");
        this.$refs[this.DIALOG_CONFIRM_MASSIVE_APPROVE].onClose();
      } else {
        this.$refs[this.DIALOG_CONFIRM_MASSIVE_APPROVE].onClose();
      }
    }
  }
};